import {Component, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from "@wms/components";
import {CommonModule} from "@angular/common";
import { Config, PrefabConfigurationService} from "@wms/settings/prefab-config";
import {FormsModule, NgForm} from "@angular/forms";
import {getPrefabIconUrl, isImageFile} from "@wms/core";
import {Subscription} from "rxjs";
import {runtimeEventManager} from "@wm/core";
import {isFileUploadSupported} from "@wavemaker/variables";
import {FileService, NotificationService} from "@wms/services";
import { isEqual } from 'lodash-es';
import { BasePrefabConfigTab } from '../base-tab-component/base-prefabconfig-tab-component.component';

@Component({
  selector: 'wms-packaging',
  templateUrl: './packaging.component.html',
  styleUrls: ['./packaging.component.less'],
  imports: [
    FormsModule,
    CommonModule
  ],
  standalone: true
})
export class PackagingComponent extends BasePrefabConfigTab implements OnInit {

  isValidIcon: boolean;
  formValueChangesSubscription: Subscription;
  iconUrl: string;
  uploadedIconValue: any;
  uploadedIconFile: any;
  @ViewChild('packagingForm', {static: true}) override packagingForm: NgForm;

  constructor(private notificationService: NotificationService, private fileService: FileService) {
    super();
    this.prefabConfig = this.prefabConfigService.getConfig();
    this.isValidIcon  = true;
    this.iconUrl      = getPrefabIconUrl(this.prefabConfig.iconUrl, this.projectService.getProjectId());
    this.registerDestroyListener.add(runtimeEventManager.on('upload-prefab-icon').subscribe(() => this.uploadPrefabIcon()));
  }

  ngOnInit() {
    let setInitialValue: boolean = true;
    if (this.initialPackaging) {
      setInitialValue = false;
    }
    this.formValueChangesSubscription = this.packagingForm.form.valueChanges.subscribe(() => {
        if (!this.packagingForm.form.dirty && setInitialValue) {
          this.initialPackaging = this.packagingForm.form.value;
        }
        this.prefabConfigService.isInvalid['packaging'] = this.packagingForm.form.invalid;
        if(this.packagingForm.form.dirty && !isEqual(this.initialPackaging,this.packagingForm.form.value))
        this.prefabConfigService.isDirty['packaging'] = true;
    });

  }

  prefabIconChange() {
    let fileEle: any = document.getElementById('icon-input');
    if(fileEle){
      // @ts-ignore
      let fileSize = fileEle.files[0].size / 1024; // in KB
      if (fileSize > 50) {
        this.isValidIcon = false;
        // @ts-ignore
        fileEle.value = '';
      } else {
        this.uploadedIconValue  = fileEle.value;
        this.uploadedIconFile   = fileEle.files[0];
        this.isValidIcon = true;
        this.prefabConfigService.prefabIconUpdated    = true;
        this.prefabConfigService.isDirty['packaging'] = true;
      }
    }
  }

  uploadPrefabIcon() {
    let formData, uploadConfig, prefabIconUploadPath: string, updatedIconUrl: string;

    if (this.uploadedIconValue && this.uploadedIconValue.indexOf('\\') > -1)
      this.uploadedIconValue = this.uploadedIconValue.split('\\').pop();

    // checking if selected file for upload is an image
    if (!isImageFile(this.uploadedIconValue)) {
      this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, this.locale.MESSAGE_ERROR_IMAGE_INVALID_FILE);
      return;
    }

    /*getting the icon upload location*/
    prefabIconUploadPath  = this.prefabConfig.iconUrl.substr(1, this.prefabConfig.iconUrl.lastIndexOf('/'));
    updatedIconUrl        = '/' + prefabIconUploadPath + this.uploadedIconValue.replace(/[^A-Z0-9\/\.\-]/ig, "_");

    /*testing for presence of File API*/
    if (isFileUploadSupported()) {
      /* Angular does not bind file values so using native object to send files */
      formData = new FormData();
      /* Take the first selected file */
      formData.append('file', this.uploadedIconFile);
      /*creating the config for upload resource*/
      uploadConfig = {
        action  : 'upload',
        path    : prefabIconUploadPath,
        content : formData
      };

      /* Call service method to upload file */
      this.fileService.upload(uploadConfig).then(() => {
        this.prefabConfigService.prefabIconUpdated  = false;
        this.prefabConfig.iconUrl                   = updatedIconUrl;
        this.iconUrl                                = getPrefabIconUrl(this.prefabConfig.iconUrl, this.projectService.getProjectId());
        this.prefabConfigService.iconUpload$.next('');
        console.log('upload success', this.prefabConfig.iconUrl);
      }, (error: any) => {
        this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, this.locale.MESSAGE_ERROR_IMAGE_INVALID_FILE)
      });
    }
  }

  override ngOnDestroy() {
    this.formValueChangesSubscription.unsubscribe();
    super.ngOnDestroy();
  }
}
